<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <div class="modal-header-left">
          <h3>Order Request Schedule</h3>
        </div>
        <div class="modal-header-right">
          <button
              class="header-btn close"
              @click="closeModal"
              title="Close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>

      <!-- Show Loading Spinner -->
      <div v-if="loading" class="loading-container">
        <i class="fa fa-spinner fa-spin"></i>
        <span>Loading...</span>
      </div>

      <!-- Order Details -->
      <div v-else class="modal-body">
        <!-- Distributor & Created At -->
        <ul>
          <li><strong>Distributor:</strong> {{ dispatchDetails.distributor }}</li>
          <li><strong>Created At:</strong> {{ dispatchDetails.created_at }}</li>
        </ul>

        <!-- Requested vs Scheduled -->
        <div class="item-details">
          <table class="table popup-table">
            <thead>
            <tr>
              <th></th>
              <th>Requested</th>
              <th>Scheduled</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Loading Time</td>
              <td>{{ dispatchDetails.loading_date_time }}</td>
              <td>{{ dispatchDetails.loading_date_time1 }}</td>
            </tr>
            <tr>
              <td>Unloading Time</td>
              <td>{{ dispatchDetails.unloading_date_time }}</td>
              <td>{{ dispatchDetails.unloading_date_time1 }}</td>
            </tr>
            <tr>
              <td>Bridging</td>
              <td>{{ dispatchDetails.briding_type }}</td>
              <td>{{ dispatchDetails.briding_type1 }}</td>
            </tr>
            <tr>
              <td>Bridging Type</td>
              <td>{{ dispatchDetails.vehicle_type }}</td>
              <td>{{ dispatchDetails.vehicle_type1 }}</td>
            </tr>
            <tr>
              <td>Vehicle</td>
              <td>{{ dispatchDetails.vehicle }}</td>
              <td>{{ dispatchDetails.vehicle1 }}</td>
            </tr>
            <tr>
              <td>Plant</td>
              <td>{{ dispatchDetails.plant }}</td>
              <td>{{ dispatchDetails.plant1 }}</td>
            </tr>
            <tr>
              <td>Destination</td>
              <td>{{ dispatchDetails.destination }}</td>
              <td>{{ dispatchDetails.destination1 }}</td>
            </tr>
            <tr>
              <td>Remarks</td>
              <td>{{ dispatchDetails.remarks }}</td>
              <td>{{ dispatchDetails.remarks1 }}</td>
            </tr>
            <tr v-if="dispatchDetails.sap_po_no && dispatchDetails.sap_po_no !== '-'">
              <td>SAP PO No</td>
              <td>-</td>
              <td>{{ dispatchDetails.sap_po_no }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Items -->
        <div class="item-details">
          <table class="table popup-table">
            <thead>
            <tr>
              <th>Items</th>
              <th>Requested Qty</th>
              <th>Scheduled Qty</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(items, index) in stockAllocations" :key="index">
              <td>{{ items.variant_name }}</td>
              <td>{{ parseInt(items.requested_qty) }}</td>
              <td>{{ parseInt(items.scheduled_qty) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchPurchaseOrderPopup } from "@/services/dataService";

export default {
  props: {
    orderId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      token: localStorage.getItem("token_set") || "",
      loading: false,
      dispatchDetails: {
        dispatch_no: "",
        created_at: "",
        vehicle: "",
        vehicle1: "",
        driver: "",
        helper: "",
        rep: "",
        distributor: "",
        route: "",
        stock_allocation_nos: "",
        loading_date_time: "",
        loading_date_time1: "",
        briding_type: "",
        briding_type1: "",
        vehicle_type: "",
        vehicle_type1: "",
        unloading_date_time: "",
        unloading_date_time1: "",
        plant: "",
        plant1: "",
        destination: "",
        destination1: "",
        remarks: "",
        remarks1: "",
        sap_po_no: "",
      },
      stockAllocations: [],
    };
  },

  methods: {
    async fetchOrderDetails() {
      this.loading = true;
      try {
        const response = await fetchPurchaseOrderPopup(this.orderId, this.token);
        const purchaseOrder = response.data.data.purchase_order;

        this.dispatchDetails = {
          dispatch_no: purchaseOrder.refrence_no[0],
          created_at: purchaseOrder.created_at[0],
          vehicle: purchaseOrder.vehicle_no[0],
          vehicle1: purchaseOrder.vehicle_no[1] || "",
          distributor: purchaseOrder.distributor_name[0],
          route: purchaseOrder.distributor_location[0],
          stock_allocation_nos: purchaseOrder.id[0],
          loading_date_time: purchaseOrder.loading_date_time[0],
          loading_date_time1: purchaseOrder.loading_date_time[1] || "",
          briding_type: purchaseOrder.bridging_name[0],
          briding_type1: purchaseOrder.bridging_name[1] || "",
          vehicle_type: purchaseOrder.vehicle_type[0],
          vehicle_type1: purchaseOrder.vehicle_type[1] || "",
          unloading_date_time: purchaseOrder.unload_date_time[0],
          unloading_date_time1: purchaseOrder.unload_date_time[1] || "",
          plant: purchaseOrder.gas_plant_name[0],
          plant1: purchaseOrder.gas_plant_name[1] || "",
          destination: purchaseOrder.distributor_location[0],
          destination1: purchaseOrder.distributor_location[1] || "",
          remarks: purchaseOrder.remarks[0] || "",
          remarks1: purchaseOrder.remarks[1] || "",
          sap_po_no: purchaseOrder.sap_po_no?.[1] || "",
        };

        this.stockAllocations = response.data.data.items;
      } catch (error) {
        console.error("Error fetching purchase order details:", error);
      } finally {
        this.loading = false;
      }
    },

    // Close Modal
    closeModal() {
      this.$emit("close");
    },
  },

  mounted() {
    this.fetchOrderDetails();
  },

  watch: {
    orderId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.fetchOrderDetails();
      }
    },
  },
};
</script>

<style scoped>
/* Modal overlay (background + centering) */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal content box */
.modal-content {
  background-color: #fff;
  padding: 0; /* padding now handled inside body */
  min-width: 400px;
  max-width: 80%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden; /* prevent overflowing */
  position: relative;
}

/* Modal header */
.modal-header {
  flex: 0 0 auto;
  padding: 15px 20px;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
}

/* Modal header - Buttons Array */
.modal-header-right {
  display: flex;
  gap: 10px;
}

/* Modal header - Button Style */
.header-btn {
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.2s ease-in-out;
}

/* Close specific colors */
.header-btn.close {
  background-color: #f8d7da; /* light red */
  color: #721c24;
}

/* Hover effect */
.header-btn:hover {
  opacity: 0.8;
}

/* Centered Loading Component */
.loading-container {
  display: flex;
  flex-direction: column; /* separate rows */
  justify-content: center;
  align-items: center;
  height: 300px; /* Adjust height to fit modal body if needed */
  font-size: 16px;
  color: #007bff;
  gap: 10px; /* spacing between spinner and text */
}

/* Promo details container (vertical stack) */
.modal-body {
  flex: 1 1 auto; /* Take remaining height */
  overflow-y: auto;
  padding: 20px; /* Add padding here instead of modal-content */
  transition: all 0.2s ease;
  position: relative;
}

/* Scrollbar styling */
.modal-body::-webkit-scrollbar {
  width: 8px;
}

/* Scrollbar Thumb styling */
.modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.2);
  border-radius: 4px;
}

/* Scrollbar Thumb Hover styling */
.modal-body::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0,0,0,0.4);
}

/* Section headings */
.modal-body h3 {
  font-size: 20px;
  margin-bottom: 12px;
  color: #333;
  font-weight: 600;
}

/* Unordered lists for details */
.modal-body ul {
  list-style-type: none;
  padding: 0;
  margin: 0 0 15px 0;
}
.modal-body ul li {
  padding: 4px 0;
  font-size: 14px;
  color: #444;
}
.modal-body ul li:last-child {
  border-bottom: none;
}

/* Order Details table (Requested vs Scheduled) */
.modal-body .popup-table.order-details {
  table-layout: fixed; /* ensure column widths are respected */
  width: 100%;
}

.modal-body .popup-table.order-details th:nth-child(1),
.modal-body .popup-table.order-details td:nth-child(1) {
  width: 20%; /* info/label column */
}

.modal-body .popup-table.order-details th:nth-child(2),
.modal-body .popup-table.order-details td:nth-child(2),
.modal-body .popup-table.order-details th:nth-child(3),
.modal-body .popup-table.order-details td:nth-child(3) {
  width: 40%; /* Requested + Scheduled columns equal */
}

.item-details {
  margin-top: 40px;
  table-layout: fixed; /* ensure column widths are respected */
  width: 100%;
  background: #a0a0a0;
}
</style>